import React, { useState } from 'react'
import { Modal } from './Modal'
import styled from 'styled-components'
import { Borders, Colors, Fonts, FontWeights, INTEGRAL_PRIVACY_URL, INTEGRAL_TERMS_URL } from '../constants'

export function ComplianceModal() {
  const [open, setOpen] = useState(true)

  return open ? (
    <ModalStyled title="Acknowledge Terms" headerTheme="dark" disableClose={true}>
      <Container>
        <P>
          By using Integral, you agree to the{' '}
          <a href={INTEGRAL_TERMS_URL} target="_blank">
            Terms of Use
          </a>{' '}
          and{' '}
          <a href={INTEGRAL_PRIVACY_URL} target="_blank">
            Privacy Policy
          </a>
        </P>
        <P>You hereby agree, represent and warrant that:</P>
        <List>
          <li>
            You are not a person or company who is a resident of, or is located, incorporated or has a registered agent
            in the United States or a restricted location.
          </li>
          <li>
            You will not in the future access this site or Integral's services while located within the United States or
            a restricted location.
          </li>
          <li>
            You are not using, and will not in the future use, a VPN to mask your physical location from a restricted
            location.
          </li>
          <li>
            You are lawfully permitted to access this site and Integral's services under the laws of the jurisdiction in
            which you reside and are located.
          </li>
          <li>
            You understand the associated risks of interacting with Integral's services, smart contracts and blockchain
            technologies.
          </li>
        </List>
        <Actions>
          <Cancel href="https://integral.link">Leave</Cancel>
          <Accept type="button" onClick={() => setOpen(false)}>
            I agree
          </Accept>
        </Actions>
      </Container>
    </ModalStyled>
  ) : null
}

const ModalStyled = styled(Modal)`
  border: 1px solid ${Colors.DarkerGray};
`

const Container = styled.div`
  padding: 15px;
  color: ${Colors.LightestGray};
  background-color: #272b31;
`

const P = styled.p`
  margin: 0 0 10px 0;
  font-size: 13px;
  font-weight: ${FontWeights.Semibold};

  a {
    color: ${Colors.White};

    &:hover {
      color: ${Colors.Hover};
    }
  }
`

const List = styled.ul`
  margin: 15px 0 20px 0;
  padding: 15px 15px 5px 33px;
  font-size: 12px;
  color: ${Colors.LightererGray};
  border-radius: ${Borders.Radius};
  background-color: rgba(255, 255, 255, 0.1);

  li {
    margin: 0 0 10px 0;
  }
`

const Actions = styled.div`
  display: flex;
  justify-content: space-between;
`

const Cancel = styled.a`
  padding: 10px;
  display: block;
  flex-basis: calc(50% - 5px);
  text-align: center;
  color: ${Colors.White};
  font-family: ${Fonts.Header};
  font-weight: ${FontWeights.Bold};
  text-decoration: none;
  text-transform: uppercase;
  background-color: ${Colors.DarkGray};
  border-radius: ${Borders.Radius};
  border: 0;
  outline: none;

  &:hover {
    background-color: ${Colors.DarkRed};
  }
`

const Accept = styled.button`
  padding: 10px;
  display: block;
  flex-basis: calc(50% - 5px);
  text-align: center;
  color: ${Colors.White};
  font-family: ${Fonts.Header};
  font-weight: ${FontWeights.Bold};
  text-transform: uppercase;
  background-color: ${Colors.Blue};
  border-radius: ${Borders.Radius};
  border: 0;
  outline: none;
  cursor: pointer;

  &:hover {
    background-color: ${Colors.LightBlue};
  }
`
